import React from "react"
import { Link } from "gatsby"
import Logo from "../../assets/kaden-logo.inline.svg"
import LogoutButton from "../Account/LogoutButton"

class Topbar extends React.Component {
  render() {
    const menu = this.props.data
    const topBar = (
      <div className="menu-wrap uk-background-primary uk-padding-xsmall uk-light">
        <div className="uk-container uk-flex uk-flex-middle uk-flex-between">
          <div className="uk-hidden@m">
            <Link to="/" className="logo-link" activeClassName="uk-active">
              <Logo className="logo logo--white" />
            </Link>
          </div>
          <div className="uk-flex uk-flex-middle uk-margin-auto-left uk-visible@m">
            {/* <Link to="/edge" className="uk-margin-left">Kaden Edge</Link> */}
            {/* <LogoutButton className="uk-margin-left" /> */}

            {menu.map((item) => (
              <div className="uk-margin-left" key={item.path}>
                <Link to={item.path} className="" activeClassName="uk-active">
                  {item.label}
                </Link>
                {item.children ? (
                  <ul className="uk-dropdown">
                    {item.children.map((child) => (
                      <li key={item.path}>
                        <Link
                          to={child.path}
                          className=""
                          activeClassName="uk-active"
                        >
                          {child.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      </div>
    )

    return topBar
  }
}

export default Topbar
